import { render, staticRenderFns } from "./CoozzySaveIcon.vue?vue&type=template&id=6d406a1a&scoped=true"
import script from "./CoozzySaveIcon.vue?vue&type=script&lang=js"
export * from "./CoozzySaveIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzySaveIcon.vue?vue&type=style&index=0&id=6d406a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d406a1a",
  null
  
)

export default component.exports